import { getAuth, signOut } from 'firebase/auth';

// eslint-disable-next-line import/prefer-default-export
export const onFinish = async (returnTo, refreshToken = null) => {
    console.log('onFinish', { returnTo, refreshToken });
    const env = process.env.REACT_APP_ENV || 'DEV';

    await signOut(getAuth());

    if (returnTo) {
        const decode = decodeURIComponent(returnTo);
        window.location.href = `${decode}?refreshToken=${refreshToken}`;
        return;
    }

    if (env === 'PROD') {
        window.location.href = `https://booking.kinto-share.com?apps=true&success=true&app_notify=1&closeview=true&refreshToken=${refreshToken}`;
        return;
    }

    window.location.href = `https://booking-test.kinto-share.com?apps=true&success=true&app_notify=1&closeview=true&refreshToken=${refreshToken}`;
};
